/**
 * Download payload to be given in QRCodeHelper.download().
 * Some preferences to the download system
 * @since 0.1.9
 * @author Kacper Faber
 */
type DownloadPayload = {
    /**
     * @default download
     * @since 0.1.9
     * @author Kacper Faber
     */
    fileName?: string | undefined;

    /**
     * Extension, must start with dot.
     * @default .png
     * @since 0.1.9
     * @author Kacper Faber
     */
    ext?: string | undefined;

    /**
     * File URL to download
     * @since 0.1.9
     * @author Kacper Faber
     */
    imageUrl: string;
};

/**
 * Full payload is translated from DownloadPayload, but without optional fields.
 * All fields here are filled.
 * @since 0.1.9
 * @author Kacper Faber
 */
type FullPayload = {
    /**
     * @default download
     * @since 0.1.9
     * @author Kacper Faber
     */
    fileName: string;

    /**
     * Extension, must start with dot.
     * @default .png
     * @since 0.1.9
     * @author Kacper Faber
     */
    ext: string;

    /**
     * File URL to download
     * @since 0.1.9
     * @author Kacper Faber
     */
    imageUrl: string;
}

/**
 * Returns the payload
 * @since 0.1.9
 * @author Kacper Faber
 */
export const toFullPayload = (dp: DownloadPayload) => {
    return { ...dp, ext: dp.ext ?? '.png', fileName: dp.fileName ?? '',} as FullPayload;
}

export default DownloadPayload;